import { TargetProtocol } from '@iotize/tap';
import {
  LowPowerOptimizationLevelConfig,
  NetworkModeConfig,
  NfcConnectionPriorityConfig,
  NfcPairingModeConfig,
  WifiKeyVisibility,
  WifiProtocol,
  WifiSSIDVisibility,
  S3PModeConfig,
} from '@iotize/tap/config/schema/v1';

type TargetProtocolConfigKey = keyof typeof TargetProtocol;

export const NetworkModeMapping: Record<string, NetworkModeConfig> = {
  P2P: 'PEER_TO_PEER',
  NETWORK: 'NETWORK',
  INFRA: 'NETWORK',
  INFRA_CLOUD: 'NETWORK', // TODO check
};

export const LowPowerOptimizationLevelMapping: Record<
  string,
  LowPowerOptimizationLevelConfig
> = {
  0: 'NO',
  1: 'SHUTDOWN',
  2: 'STANDBY', // TODO CHECK
};

export const WIFI_KEY_VISIBILITY_MAPPING: Record<string, WifiKeyVisibility> = {
  0: 'VISIBLE',
  1: 'HIDDEN',
};

export const S3P_CONFIG_MODE_MAPPING: Record<string, S3PModeConfig> = {
  0: 'EMULATION',
  1: 'INDEXED',
};

export const WIFI_SSID_VISIBILITY_MAPPING: Record<string, WifiSSIDVisibility> =
  {
    0: 'VISIBLE',
    1: 'HIDDEN',
    2: 'HIDDEN_FROM_SCAN',
  };

export const WIFI_PROTOCOL_MAPPING: Record<string, WifiProtocol[]> = {
  1: ['B'],
  3: ['B', 'G'],
  7: ['B', 'G', 'N'],
};

export const TargetProtocolMapping: Record<string, TargetProtocolConfigKey> = {
  JTAG: 'JTAG',
  MODBUS: 'MODBUS',
  NONE: 'NONE',
  S3P: 'S3P',
  SERIAL: 'SERIAL',
  SERIAL_STANDARD: 'SERIAL',
  SERIAL_VIA_TAPNPASS: 'SERIAL',
  CUSTOM: 'CUSTOM',
  SWD: 'SWD',
  GPIO: 'DIRECT_IO',
  DIRECT_IO: 'DIRECT_IO',
  DIRECTIO: 'DIRECT_IO',
  CAN: 'CAN',
  NO_TARGET_PROTOCOL: 'NONE',
  MODBUSTCP: 'MODBUS_TCP',
};

export const NFCParingModeMapping: Record<string, NfcPairingModeConfig> = {
  NO: 'NO',
  PAIRING: 'MANDATORY',
  'PAIRING+LOGIN': 'MANDATORY_FOR_LOGIN',
};

export const NFC_CONNECTION_PRIORITY_MAPPING: Record<
  string,
  NfcConnectionPriorityConfig
> = {
  0: 'NFC_NON_PRIORITY',
  1: 'NFC_PRIORITY',
};

// const MAPPING: Record<WriteConfigKey, any> = {
//     // App
//     'application.name': 'IOTizeConfiguration.IOTizeApp.#.Name',
//     'application.universalLink': 'IOTizeConfiguration.IOTizeApp.#.WebLink',
//     'application.uri': 'IOTizeConfiguration.IOTizeApp.#.GUI_Path',
//     'application.data': 'TODO',

//     // CLOUD
//     'cloud.dataLog.uploadPeriod': 'IOTizeConfiguration.IOTizeApp.CloudServices.#.CloudMqttPeriod',
//     'cloud.dataLog.mqttPublishTopic': 'IOTizeConfiguration.IOTizeApp.WIFI_INFO.#.Cloud_Publish_Topic',
//     'cloud.dataLog.mqttSubscribeTopic': 'IOTizeConfiguration.IOTizeApp.WIFI_INFO.#.Cloud_Subscribe_Topic',
//     'cloud.platform': '',

//     // Target
//     'target.protocol.type': 'IOTizeConfiguration.IOTizeApp.#.TargetProtocol',

//     // Tap
//     'tap.certificate.privateKey': 'IOTizeConfiguration.IOTizeApp.GUI_MQTT_Info.GUI_DevMQTT_PrivateKey',
//     'tap.certificate.publicKey': 'IOTizeConfiguration.IOTizeApp.GUI_MQTT_Info.GUI_DevMQTT_Certificate',

//     // JVM
//     'jvm.code': 'IOTizeConfiguration.IOTizeApp.#.JVM_Custom_Code',
//     'jvm.profileId': 'IOTizeConfiguration.IOTizeApp.#.',

//     // LORA
//     'wireless.protocols.lora.config': 'IOTizeConfiguration.IOTizeApp.LoRa_Info.#.LoRaMode',
//     'wireless.protocols.lora.ids': 'IOTizeConfiguration.IOTizeApp.LoRa_Info.#.TODO',

//     // MQTT
//     'wireless.protocols.mqtt.clientId': 'IOTizeConfiguration.IOTizeApp.WIFI_INFO.#.MQTTRelay_Client_ID',
//     'wireless.protocols.mqtt.password': 'IOTizeConfiguration.IOTizeApp.WIFI_INFO.#.MQTTRelay_Passwd',
//     'wireless.protocols.mqtt.username': 'IOTizeConfiguration.IOTizeApp.WIFI_INFO.#.MQTTRelay_Broker_Login',
//     'wireless.protocols.mqtt.brokerPort': 'IOTizeConfiguration.IOTizeApp.WIFI_INFO.#.MQTTRelay_Service',
//     'wireless.protocols.mqtt.brokerHostname': 'IOTizeConfiguration.IOTizeApp.WIFI_INFO.#.MQTTRelay_URL',
//     'wireless.protocols.mqtt.brokerCertificate': 'IOTizeConfiguration.IOTizeApp.WIFI_INFO.#.Broker_Certificate',
//     'wireless.protocols.mqtt.topicPrefix': 'IOTizeConfiguration.IOTizeApp.WIFI_INFO.#.TODO',

//     // NFC
//     'wireless.protocols.nfc.autoLogProfileId': 'IOTizeConfiguration.IOTizeApp.#.NFCLogin',
//     'wireless.protocols.nfc.connectionPriority': 'IOTizeConfiguration.IOTizeApp.#.NFCInterruptionLock',
//     'wireless.protocols.nfc.pairingMode': 'IOTizeConfiguration.IOTizeApp.#.NFCPairingMandatory',

//     // WIFI
//     'wireless.protocols.wifi.ssid': 'IOTizeConfiguration.IOTizeApp.WIFI_Info.ModuleSSID ||',
//     'wireless.protocols.wifi.ssidVisibility': 'IOTizeConfiguration.IOTizeApp.WIFI_Info.Wifi_SSID_Hidden',
//     'wireless.protocols.wifi.keyVisibility': 'IOTizeConfiguration.IOTizeApp.WIFI_Info.#.Wifi_WEPKey_Hidden',
//     'wireless.protocols.wifi.gatewayIp': 'IOTizeConfiguration.IOTizeApp.WIFI_Info.#.',
//     'wireless.protocols.wifi.mask': 'IOTizeConfiguration.IOTizeApp.WIFI_Info.#.',
//     'wireless.protocols.wifi.mode': 'IOTizeConfiguration.IOTizeApp.WIFI_Info.#.',
//     'wireless.protocols.wifi.protocol': 'IOTizeConfiguration.IOTizeApp.WIFI_Info.#.',
//     'wireless.protocols.wifi.region': 'IOTizeConfiguration.IOTizeApp.WIFI_Info.#.',

//     // Wireless options
//     'wireless.options.inactivityTimeout': 'IOTizeConfiguration.IOTizeApp.WIFI_Info.#.',
//     'wireless.options.authorizedProtocols': 'IOTizeConfiguration.IOTizeApp.WIFI_Info.#.',

//     'data.profiles[]': 'IOTizeConfiguration.IOTizeApp.IOTizeProfile',
//     'data.profiles[].username': '#.Name',
//     'data.profiles[].alias': '#.GroupId',
//     'data.profiles[].lifeTime': '#.LifeTime',
//     'data.profiles[].passwordKey': '#.Pwd',
//     'data.profiles[].password': false,

//     'data.bundles[]': 'IOTizeConfiguration.IOTizeApp.IOTizeBundle',
//     'data.bundles[].name': '#.Name',
//     'data.bundles[].dataLog.period': '#.DataLogPeriod',
//     'data.bundles[].acl[].$': '#.',

//     'data.variables[].address': '',
//     'data.variables[].bundleId': '',
//     'data.variables[].type': '',
//     'data.variables[].value': '',

// }
